import React, {Component} from "react";
import { isSimilarObject } from "../../../helper";

export default class BalanceIndividual extends Component {

    componentDidUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {

        const {
            currentUser,
            withdrawMoney,
            showBalancePopup2
        } = this.props;

        return (
            <div className="my-balance" style={{marginTop: 0, paddingTop: '30px'}}>
                <div className="balance-state" style={{marginBottom:'5px'}}>
                    <h3>Счёт заказчика:</h3>
                    <span className="money">{currentUser.balance_customer} р.</span>
                </div>
                <div className="balance-state">
                    <h3>Счёт исполнителя:</h3>
                    <span className="money">{currentUser.balance_contractor} р.</span>
                </div>
                <div className="my-balance-actions">
                    <div className="big-button orange-button-gradient balance-btn">
                        <button onClick={() => showBalancePopup2()}>Пополнить баланс</button>
                    </div>
                    <div className="big-button violet-button-gradient">
                        <button onClick={() => withdrawMoney()}>Вывести средства</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Account/Balance/Balance.js